import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
`;

export const HeaderRow = styled.tr`
  background-color: #f5f5f5;
`;

export const Th = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #122d58;
  border-bottom: 2px solid #ddd;
  font-size: 14px;
`;

export const Tr = styled.tr`
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  color: #333;
`;

